import { type IHttpApiFetchConfig } from '@cian/http-api';

import { type TJsonQuery } from '@/packages/JsonQuery';
import { setRegionId } from '@/packages/JsonQuery/setRegionId';

import { type IApplicationContext } from '../types/applicationContext';
import { type TLocation } from '../types/location';
import { normalizeLocationId } from '../utils/location/normalizeLocationId';

import { fetchGetMetaSafe } from './fetchGetMetaSafe';

type TParams = { location: TLocation; jsonQuery: TJsonQuery };

export async function fetchGetMetaWithFixedGeo(
  context: IApplicationContext,
  { location, jsonQuery }: TParams,
  fetchConfig?: IHttpApiFetchConfig,
): Promise<Awaited<ReturnType<typeof fetchGetMetaSafe>>> {
  let jsonQueryPatched = jsonQuery;
  const { geo, region, id_user } = jsonQuery;

  if (!geo && !region && !id_user) {
    jsonQueryPatched = setRegionId(jsonQuery)([normalizeLocationId(location)]);
  }

  return fetchGetMetaSafe(context, { jsonQuery: jsonQueryPatched }, fetchConfig);
}
